import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import OrderManagementApiService from './OrderManagementApiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { CREATE_BILL_OF_SALE, GET_BILL_OF_SALE_URL, UPLOAD_ASSET_ORDER_DETAIL_ATTACHMENTS } from 'Store/OrderManagement/BillOfSale/BillOfSaleType';
import { setAssetOrderDetailAttachments, setBillOfSaleUrl } from 'Store/OrderManagement/BillOfSale/BillOfSaleAction';

function* uploadAssetOrderDetailAttachments(payload: any): any {
    try {
        yield put(globalLoaderText("Uploading Attachments...."));
        let payloadData: IPayload = {
            apiType: apiType.OrderManagement,
            endpoint: `orders/asset/orderattachments`,
            apiMethod: apiMethod.POST,
            payload: payload.payload
        }
        const response = yield call(
            OrderManagementApiService.post, API_URL.PostWebApp, payloadData
        );

        if (response) {
            // yield put(setAssetOrderDetailAttachments(response));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        // yield put(setAssetOrderDetailAttachments([]))
        yield put(globalLoaderText(""));
    }
}

function* createBillOfSale(payload: any): any {
    try {
        yield put(globalLoaderText("Creating Bill Of Sale...."));
        let payloadData: IPayload = {
            apiType: apiType.OrderManagement,
            endpoint: `orders/disposition/createbillofsale`,
            apiMethod: apiMethod.POST,
            payload: payload.payload
        }
        const response = yield call(
            OrderManagementApiService.post, API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setBillOfSaleUrl(response));
            yield put(globalLoaderText(""));
        }
    }
    catch (error) {
        yield put(setBillOfSaleUrl({}))
        yield put(globalLoaderText(""));
    }
}

function* getBillOfSaleUrl(payload: any): any {
    try {
        yield put(globalLoaderText("Creating Bill Of Sale...."));
        let payloadData: IPayload = {
            apiType: apiType.OrderManagement,
            endpoint: `orders/createDispoBOS?orderId=${payload.payload}`,
            apiMethod: apiMethod.POST,
            payload: null
        }
        const response = yield call(
            OrderManagementApiService.post, API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setBillOfSaleUrl(response));
            yield put(globalLoaderText(""));
        }
    }
    catch (error) {
        yield put(setBillOfSaleUrl({}))
        yield put(globalLoaderText(""));
    }
}

function* watchReasonCode() {
    yield takeEvery(UPLOAD_ASSET_ORDER_DETAIL_ATTACHMENTS, uploadAssetOrderDetailAttachments);
    yield takeEvery(CREATE_BILL_OF_SALE, createBillOfSale);
    yield takeEvery(GET_BILL_OF_SALE_URL, getBillOfSaleUrl);
}

export default function* combinedSaga() {
    yield all([
        watchReasonCode()
    ])
}
